var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPadoCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 118,
    viewBox: "0 0 117 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.853591,
    y: 59.0268,
    width: 81.5167,
    height: 81.5167,
    rx: 12.5,
    transform: "rotate(-45 0.853591 59.0268)",
    fill: "url(#paint0_linear_110_2418)",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0111 68.5481H48.5741V65.3983H45.6439V45.1015H62.703C67.321 45.1015 70.5481 47.6138 72.3678 51.1065C73.379 53.1003 73.9804 55.2676 74.1381 57.4864C74.3243 59.7503 74.0858 62.0284 73.4344 64.2091C72.1699 68.3231 69.3056 71.6926 64.9075 72.4425C63.2081 72.6457 61.4937 72.7048 59.7838 72.6193C58.8657 72.5871 57.9147 72.5871 57.4583 72.5871H57.4583V75.753H59.7343C61.6447 75.8519 63.5603 75.7802 65.4573 75.5387C71.2573 74.5584 74.9462 70.2891 76.5405 65.0984C77.3202 62.5507 77.6146 59.8856 77.4091 57.2346C77.2171 54.5984 76.5001 52.0239 75.2981 49.6548C72.9506 45.1337 68.7834 41.9196 62.736 41.9196H42.3948V68.5481H44.0111ZM61.8954 49.2094H50.3504L50.3339 52.3967H50.3504V65.3815H50.3339V68.5366L50.3504 68.5367V72.6132L42.5712 72.5703L42.5822 75.7254L51.9777 75.7576L53.5995 75.7415V68.5458C57.076 68.5522 60.3791 68.5465 61.1147 68.5099H61.2797L61.2925 68.5093C63.5411 68.407 69.79 68.1229 69.79 59.0337C69.768 49.7451 61.9229 49.2094 61.8954 49.2094ZM53.5995 65.3815H60.9498H61.1202C62.5496 65.3172 66.5574 65.1351 66.5464 59.0605C66.5464 53.1306 62.2857 52.461 61.714 52.3967H53.5995V65.3815Z",
    fill: "#0A1214"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_110_2418",
    x1: 78.5511,
    y1: 62.4394,
    x2: 2.89067,
    y2: 138.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.513642,
    stopColor: "#34DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6FFE5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadoCard);
export default __webpack_public_path__ + "static/media/padoCard.b3b861e74f32710a191e4c52d720782a.svg";
export { ForwardRef as ReactComponent };